// extracted by mini-css-extract-plugin
export default {"content":"mIH5seX8D6KoWJnPPsTG","device":"Q3MWRCUXx_fmYyOh2uey","device__body":"MvRdpRBxNuX4KHYmMHpL","device__icon":"Io8VTNjAKUrXvg6AN86k"};